import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SearchRoutingModule} from './search-routing.module';
import {SearchComponent} from './search/search.component';
import {SearchResultsComponent} from './search-results/search-results.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatDialogModule} from "@angular/material/dialog";
import {SearchProductsComponent} from './search-products/search-products.component';
import {SearchProductPreviewComponent} from './search-product-preview/search-product-preview.component';
import {PipeModule} from "../pipe/pipe.module";
import {LoaderModule} from "../loader/loader.module";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ProductListingModule} from "../product/product-listing/product-listing.module";


@NgModule({
	declarations: [
		SearchComponent,
		SearchResultsComponent,
		SearchProductsComponent,
		SearchProductPreviewComponent
	],
	imports: [
		CommonModule,
		SearchRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		MatIconModule,
		MatProgressBarModule,
		MatDialogModule,
		PipeModule,
		LoaderModule,
		MatProgressSpinnerModule,
		ProductListingModule
	]
})
export class SearchModule {
}
